import { NavigationBar as NavigationBarBase } from '@vivaldis/web-ui'
import { useTranslation } from 'react-i18next'

export const NavigationBar = () => {
  const { t } = useTranslation()

  return <NavigationBarBase title={t('screens.not_found.header')} />
}
